import axios from "axios";
import request from "../httpService";

import config from "../../config";

const { apiHost } = config().secrets;

export async function getBusinessCategory() {
	const url = "/api/getBusinessCategory";
	const { data } = await request.get(url);
	return data;
}

export async function getBusinessType(businessCategory, region) {
	const url = "/api/getBusinessType";
	const { data } = await request.get(url, {
		params: { businessCategory, region },
	});
	return data;
}

export async function getProductCategory(bizFrom, region) {
	const url = "/api/getProductCategory";
	const { data } = await request.get(url, {
		params: { bizFrom, region },
	});
	return data;
}

export async function getProductMedium() {
	const url = "/api/getProductMedium";
	const { data } = await request.get(url);
	return data;
}

export async function getNotFound(region) {
	const url = `${apiHost}/api/notFound`;
	const { data } = await axios.get(url, {
		params: { region },
	});
	return data;
}

export async function fetchPartners(region, page, direction) {
	const url = "/api/customer/fetchPartners_web";
	const { data } = await request.get(url, {
		params: { region, page: page || null, direction: direction || null },
	});
	return data;
}

export async function searchPartners(region, page, direction, keyword) {
	const url = "/api/customer/searchPartner_web";
	const { data } = await request.get(url, {
		params: {
			region,
			page: page || null,
			direction: direction || null,
			keyword,
		},
	});
	return data;
}

export async function fetchPartnerRating(params) {
	const url = "/api/fetchPartnerRating";
	const { data } = await request.get(url, { params });
	return data;
}

export async function addMailingList(payload) {
	const url = "/api/customer/postMailingList";
	const { data } = await request.post(url, payload);
	return data;
}

export async function fetchFaqs(params) {
	const url = "/api/customer/getFaq";
	const { data } = await request.get(url, { params });
	return data;
}

export async function getAboutSmartDeals(params) {
	const url = "/api/customer/getAboutSmartDeals";
	const { data } = await request.get(url, { params });
	return data;
}

export async function submitContactUs(payload) {
	const url = "/api/customer/contactUs";
	const { data } = await request.post(url, payload);
	return data;
}

export async function getUserIP() {
	const { data } = await axios.get("https://api.ipify.org/?format=json");
	return data;
}

export async function getEventReport(params) {
	const { data } = await request.get("/api/event/getEventReport", {
		params,
	});
	return data;
}

export async function sendOtp(payload) {
	const url = "/api/customer/send-otp";
	const { data } = await request.post(url, payload);
	return data;
}

export async function resendOtp(payload) {
	const url = "/api/customer/resend-otp";
	const { data } = await request.post(url, payload);
	return data;
}

export async function verifyOtp(payload) {
	const url = "/api/customer/verify-otp";
	const { data } = await request.post(url, payload);
	return data;
}

export async function deleteAccount(payload) {
	const url = "/api/customer/delete-account";
	const { data } = await request.post(url, payload);
	return data;
}

export async function fetchMyReferrals(params) {
	const { data } = await request.get("/api/fetchMyReferrals", {
		params,
	});
	return data;
}

export async function fetchBusinessSummary(params) {
	const timeout = 300000;

	const { data } = await request.get("/api/businessSummary", {
		params,
		timeout,
	});
	return data;
}

export async function getAccountStatement(payload) {
	const { data } = await request.post("/api/accountStatement", payload);
	return data;
}
